// extracted by mini-css-extract-plugin
export var formContainer = "_lz-0";
export var message = "_lz-1";